import { render } from "./DorDistribution.vue?vue&type=template&id=1acc7002&scoped=true"
import script from "./DorDistribution.vue?vue&type=script&lang=js"
export * from "./DorDistribution.vue?vue&type=script&lang=js"

import "./DorDistribution.vue?vue&type=style&index=0&id=1acc7002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acc7002"]])

export default __exports__